// Detect Apple devices that can install .pkpass files natively.
// Modern iPads identify as Mac in their user agent, so we also accept the
// touch-enabled "MacIntel" case (iPadOS 13+).
export const isAppleWalletCapable = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";

  const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const iPadOSDesktopUA =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  return iOS || iPadOSDesktopUA;
};
